import React from 'react';
import { Link } from 'react-router-dom';

export const Mark = ({ size = 24, className }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        aria-hidden="true"
    >
        <rect x="2" y="8" width="14" height="14" fill="currentColor" />
        <rect x="11" y="2" width="10" height="10" style={{ fill: 'var(--accent)' }} />
    </svg>
);

const Brand = ({ to = '/', size = 24 }) => (
    <Link to={to} className="brand" aria-label="FreightSource home">
        <Mark size={size} className="brand-mark" />
        <span className="brand-wordmark">FreightSource</span>
    </Link>
);

export default Brand;
